export default __webpack_public_path__ + "static/media/pantry2-after2.df27169e.jpg";